<template>
    <b-modal
        id="add-tag-modal"
        :title="$t('modules.add_tag')"
        :ok-title="$t('modules.add_tag')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @show="onShow()"
        @ok="onOk()"
        modal-class="apprentice-default-modal">
        <label>{{ $t('common.name') }}</label>
        <b-form-input v-model="name"></b-form-input>

        <label>{{ $t('common.colour') }}</label>
        <design-2021-colorpicker
            id="module-new-tag-color-input"
            :color="createdTagcolor"
            @on-close="addColorToTag"></design-2021-colorpicker>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';

const moduleTagsOrds = ords.use('module_tags');

export default {
    name: 'design-2021-modules-add-tag-modal',
    data() {
        return {
            name: '',
            createdTagcolor: '#ffffff',
        };
    },
    methods: {
        addColorToTag(color) {
            this.createdTagcolor = color;
        },

        onOk() {
            let data = {
                name: this.name,
                color: this.createdTagcolor,
            };

            this.alert.saving();

            this.axios.post(this.routes.addModuleTag(), data).then(
                (response) => {
                    moduleTagsOrds.add(response.data);

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.name = '';
        },
    },
};
</script>

<style scoped></style>
